/**
 * adminApi.js — Platform-admin-only endpoints (/api/admin/*).
 *
 * Every call requires the caller's `X-User-Id` to be in the backend's
 * `PLATFORM_ADMIN_USER_IDS` env list; otherwise the server returns 403.
 * The frontend enforces the same gate before mounting the route, but
 * the server remains authoritative.
 */
import { get, post, del, requireParam } from './httpClient';

const BASE = '/api/admin';

export const getPlatformStats = () => get(`${BASE}/stats`);

export const listAllTenants = ({ q, status } = {}) => {
  const params = {};
  if (q)      params.q = q;
  if (status) params.status = status;
  return get(`${BASE}/tenants`, params);
};

export const getTenantDetail = (tenantId) => {
  requireParam('tenantId', tenantId);
  return get(`${BASE}/tenants/${tenantId}`);
};

export const suspendTenant    = (tenantId) => { requireParam('tenantId', tenantId); return post(`${BASE}/tenants/${tenantId}/suspend`); };
export const reactivateTenant = (tenantId) => { requireParam('tenantId', tenantId); return post(`${BASE}/tenants/${tenantId}/reactivate`); };
export const archiveTenant    = (tenantId) => { requireParam('tenantId', tenantId); return post(`${BASE}/tenants/${tenantId}/archive`); };

export const hardDeleteTenant = (tenantId, slug) => {
  requireParam('tenantId', tenantId);
  requireParam('slug', slug);
  return del(`${BASE}/tenants/${tenantId}/hard?confirm=${encodeURIComponent(slug)}`);
};

export const startImpersonation = (tenantId) => { requireParam('tenantId', tenantId); return post(`${BASE}/tenants/${tenantId}/impersonate`); };
export const stopImpersonation  = (tenantId) => { requireParam('tenantId', tenantId); return post(`${BASE}/tenants/${tenantId}/stop-impersonate`); };
